import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BuildingView } from '@api-proxies';
import { BuildingService } from '@http/clients/building.service';
import { TabNames } from '@models/enums/TabNames';
import { EditorComponentBase } from 'ngx-lib';
import { InternalNavigatorComponent } from '../../internal-navigator/internal-navigator.component';
import { LocationDetailsComponent } from '../../location-details/location-details.component';
import { StaticMapComponent } from '../../static-map/static-map.component';
import { TypeAheadBuildingsComponent } from '../../type-ahead-buildings/type-ahead-buildings.component';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-building-editor',
    templateUrl: './building-editor.component.html',
    styleUrls: ['./building-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        StaticMapComponent,
        InternalNavigatorComponent,
        TypeAheadBuildingsComponent,
        ValidationErrorMessageComponent,
        LocationDetailsComponent
    ]
})
export class BuildingEditorComponent extends EditorComponentBase<number | undefined> implements OnInit {
    selectedBuilding?: BuildingView;

    displaySelectedBuilding = true;

    isBuildingOverview?: boolean;

    showInternalNavigator?: boolean;

    routeToSingle?: string;

    private readonly buildingService = inject(BuildingService);

    constructor() {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.isBuildingOverview = this.additionalInfo?.isBuildingOverview;
        this.showInternalNavigator = this.additionalInfo?.allowToNavigate;
        if (this.bindingProperty) {
            this.selectedBuilding = await this.buildingService.getById(this.bindingProperty);
            this.setRouteToNavigate(this.selectedBuilding);
        }
    }

    onSelectedBuilding(building: BuildingView) {
        this.selectedBuilding = building;
        if (this.selectedBuilding) {
            (this.bindContext as any)['line2'] = building.line2;
            (this.bindContext as any)['buildingAddressId'] = building.addressId;
        }
        this.bindingProperty = this.selectedBuilding?.id;
        if (this.bindingProperty) this.setRouteToNavigate(this.selectedBuilding);
        this.validate();
        this.valueChange.emit();
    }

    setRouteToNavigate(building: BuildingView) {
        this.routeToSingle = `buildings-single/${building.id}/${TabNames[TabNames.Overview]}`;
    }
}
